import HOCInput from 'components/common/hoc-input';
import Separator from 'components/common/separator';
import Text from 'components/elements/text';
import { CardSection } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import TourFlightItem from './items/flight';

export default function TourFlightCard() {
  const { t } = useTranslation();

  return (
    <CardSection>
      <Text variant="HeadingXSmall">
        {t('common:detail_extra', { extra: t('common:flight') })}
      </Text>
      <HOCInput
        keys={['approvalable.tourFlights']}
        children={(value) => (
          <>
            {(value['approvalable.tourFlights'] || []).map((tf, idx) => (
              <React.Fragment key={tf.refId}>
                <Separator gap={16} direction="vertical" />
                <TourFlightItem parentIdx={idx} />
              </React.Fragment>
            ))}
          </>
        )}
      />
    </CardSection>
  );
}
